import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/technologies/cloud-computing/page.tsx");
